export default {
  meta: {
    label: 'Tagalog'
  },
  data: {
    'tl': {
      97: [
        ['🦅', 'agila'],
        ['🐍', 'ahas'],
        ['👽', 'alien'],
        ['🌊', 'alon'],
        ['⚓️', 'angkla'],
        ['🐶', 'aso']
      ],
      98: [
        ['🐄', 'baka'],
        ['🧒', 'bata'],
        ['👶', 'bata'],
        ['👄', 'bibig'],
        ['⭐️', 'bituin'],
        ['🎻', 'biyolin'],
        ['🐝', 'bubuyog'],
        ['🌺', 'bulaklak'],
        ['🌋', 'bulkan'],
        ['🦎', 'butiki'],
        ['🌝', 'buwan']
      ],
      99: [['🤠', 'cowboy'], '🛶'],
      100: [],
      101: [],
      102: ['🍟', 'fries'],
      103: [['👻'], '🦍'],
      104: [['🐹', 'hamster'], ['🥅', 'hockey net'], ['🏒', 'hockey stick']],
      105: [['👃', 'ilong'], ['🥚', 'itlog']],
      106: [['🕹️', 'joystick']],
      107: [['⚡️', 'kidlat'], ['🐇', 'kuneho'], ['🔪', 'kutsilyo']],
      108: [['🦁', 'leon'], ['🐆', 'leopardo']],
      109: [
        ['💃', 'mananayaw'],
        ['🍎', 'mansanas'],
        ['👁️', 'mata'],
        ['📫', 'mailbox'],
        ['👖', 'maong'],
        '🍈'
      ],
      110: [['🚶', 'naglalakad'], ['🎶', 'nota']],
      111: [],
      112: [
        ['👣', 'paa'],
        ['🦃', 'pabo'],
        ['🍉', 'pakwan'],
        ['🐸', 'palaka'],
        ['🥘', 'palayok'],
        ['☂️', 'payong'],
        ['🥞', 'pancake'],
        ['🦇', 'paniki'],
        ['🆙', 'pataas'],
        ['🍐', 'peras'],
        ['🐙', 'pugita'],
        ['🐈', 'pusa'],
        ['🐱', 'pusa'],
      ],
      113: ['🇶🇦'],
      114: [['👸🏻', 'reyna'], ['🤖', 'robot'], ['♻️', 'recycling'], ['🚀', 'rocket']],
      115: [
        ['🍌', 'saging'],
        ['🥗', 'salad'],
        ['🤹🏼‍♀️', 'salamangka'],
        ['🤳', 'selfie'],
        ['👌', 'sige'],
        ['🤐', 'siper'],
        ['🔑', 'susi'],
      ],
      116: [['🌮', 'taco'], ['❓', 'tandang pananong'], ['🐯', 'tigre'], ['🐅', 'tigre']],
      117: [['🍇', 'ubas'], ['🦌', 'usa'], ['🦄', 'unicorn']],
      118: [['🏐', 'volleyball']],
      119: [],
      120: [],
      121: [['💴', 'yen'], '☯️'],
      122: []
    }
  }
};

